import BaseService from "./base.service";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";

export default class CategoryService extends BaseService {
  getCategoriesMulti = () => {
    return this.axios.get(API_ENDPOINTS.CATEGORIES_MULTI);
  };
}


